<template>
	<BasicLayout>

		<el-card class="filter-card">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="7" :lg="5" :xl="5" class="col1">
					<el-date-picker size="small"
						start-placeholder="Date de début"
						end-placeholder="Date de fin"
						range-separator="au"
						prefix-icon="far fa-calendar-alt"
    					v-model="criteria.dateRange"
						v-on:input="setRange"
						type="daterange"
						format="dd MMM yyyy"
						:clearable="false"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-col>

				<el-col :xs="{span: 12, offset: 6}" :sm="{span: 5, offset: 7}" :md="{span: 4, offset: 13}" :lg="{span: 3, offset: 16}" :xl="{span: 2, offset: 17}" class="col2">
					<el-button 
						class="cgu-btn"
						size="small" 
						type="primary" 
						icon="fas fa-download"
						title="Télécharger la liste des CGU acceptées"
						v-on:click="getCSV()">
						CGU acceptées
					</el-button>
				</el-col>
			</el-row>
		</el-card>

		<el-card class="histories-card">
			 <template>
				<el-table
				:data="histories"
				v-loading="loading"
				height="calc(100vh - 330px)"
				style="width: 100%"
				class="histories-table">
				<el-table-column
					label="Date"
					width="150">
					<template slot-scope="scope">
							{{scope.row.date}}
					</template>
				</el-table-column>
				<el-table-column
					width="100"
					label="Action"
					class="col-table-type1">
					<template slot-scope="scope">
							{{scope.row.actionType.name}}
					</template>
				</el-table-column>
				<el-table-column
					label="Utilisateur"
					width="200">
					<template slot-scope="scope" class="col-table-type1">
							{{scope.row.user.lastname}} {{scope.row.user.firstname}}
					</template>
				</el-table-column>
				<el-table-column
					min-width="400"
					prop="text"
					label="Texte">
				</el-table-column>
				</el-table>
			</template>

		</el-card>

		<div class="block-pagination">
			<el-pagination
				background
				@current-change="handleCurrentChange"
				layout="prev, pager, next"
				:total="nbElements"
				:current-page="currentPage">
			</el-pagination>
		</div>

	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout.vue'
import HistoryService from '@/services/history.service'
import CguService from '@/services/cgu.service'
import moment from 'moment';

export default {
	name: 'checkups',
	components: {
		BasicLayout
	},

	data: function () {
		return {
			histories: [],
			loading: true,
			criteria: {
				dateRange: [],
				defaultDateRange: true
			},
			currentPage: 1,
			nbElements: 0
		}
	},

	methods: {

		handleCurrentChange(val) {
			// Positionne la pagination à la page val
			this.currentPage = val;
			// Récupère la liste historique de la page val
			this.getData(val-1,10);	
		},

		setRange() {
			
			// Positionne un flag pour dire que les dates par défaut ont été modifiée
			this.criteria.defaultDateRange = false

			// Mémorise les critères de recherche en session
			this.saveCriteria()

			// Positionne la pagination à la première page
			this.currentPage = 1;

			// Récupère la liste historique
			this.getData(0,10);
		},
		getData(page,elements) {
			
			// Appel de l'api
			HistoryService.getHistory(this.criteria.dateRange,page,elements).then((histories) => {

				// Pour chaque ligne
				histories.forEach(history => {
					history.date = moment(history.date).format('LLL');		
				});

				// Appel de l'api nombre d'éléments
				HistoryService.countHistoryElements(this.criteria.dateRange).then((nbElements) => {
					this.nbElements = nbElements;
				});

				this.histories = histories
				this.loading = false

			})
		},
		saveCriteria() {

			// Mémorise les critères de recherche en session
			sessionStorage.setItem("criteria_histories", JSON.stringify(this.criteria))
		},
		getCSV() {

			CguService.downloadCSV()
		}
    },
	mounted: function() {

		// Charge les critères de recherche mémorisé en session
		const sessionCriteria = sessionStorage.getItem("criteria_histories")
		if (sessionCriteria) {
			this.criteria = JSON.parse(sessionCriteria)
		}
	

		// Initialise les dates par défauts
		if (this.criteria.defaultDateRange) {
			this.criteria.dateRange = [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
		}

		// Récupère la liste historique
		this.getData(0,10)
		
	}
}
</script>

<style>

	.filter-card {
		margin-bottom: 10px;
	}

	.histories-card {
		height: calc(100vh - 290px);
	}

	.el-table .cell {
		padding-left: 5px;
		padding-right: 5px;
	}

	.cell {
		word-break: normal;
	}

	.col1 > div {
		width: 100% !important;
	}

	.block-pagination{
		text-align: center;
	}

	.col2 .cgu-btn {
		width: 100%;
	}

@media only screen and (max-width:991px) {
	.col1 {
		margin-bottom: 10px;
	}

	.histories-card {
		height: calc(100vh - 290px);
	}

	.histories-table {
		height: calc(100vh - 330px) !important;
	}
}

@media only screen and (max-width:767px) {
	.col1 {
		margin-bottom: 10px;
	}


	.histories-card {
		height: calc(100vh - 240px);
	}

	.histories-table {
		height: calc(100vh - 280px) !important;
	}
}

</style>
